import { Injectable } from '@angular/core';
import{LoginResponse} from '../../models/login/login'
import { HttpClient,HttpParams, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
// import { RequestOptions } from '@angular/http';
import {Observable,throwError,BehaviorSubject } from 'rxjs';
import {catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SpeakerService {
  private trainingUrl: string;
  private logOutURL: string;
  private allTrainingUrl: string;
  private upcommingUrl: string;
  private storyUrl:string;
  private profileUrl: string;
  private trainingByIdUrl: string;
  private trainingUpdateByIdUrl: string;
  private allMaterialsUrl: string;
  private updateCertificationUrl:string;

  constructor(private http: HttpClient) { 
    this.updateCertificationUrl=environment.apiUrl+'/patientspeaker/training/updateCertification'
    this.allMaterialsUrl=environment.apiUrl + '/patientspeaker/getAllMaterials?';
    this.trainingUrl = environment.apiUrl + '/patientspeaker/getTraining?';
    this.allTrainingUrl = environment.apiUrl + '/patientspeaker/training/getAllTraining?';
    this.upcommingUrl=environment.apiUrl + '/patientspeaker/events/list?';
    this.storyUrl=environment.apiUrl + '/patientspeaker/story?';
    this.profileUrl = environment.apiUrl + '/patientspeaker/getProfile?';
    this.trainingByIdUrl=environment.apiUrl + '/patientspeaker/training/';
    this.trainingUpdateByIdUrl=environment.apiUrl + '/patientspeaker/training/updateTraining';
    this.logOutURL=environment.apiUrl + '/logout';
  }
    getTraining(limit,start,user_id){
    console.log(" this.trainingURL", this.trainingUrl);
    const httpOptions = {
    headers: new HttpHeaders({
    'Content-Type':  'application/json'
    }),
    withCredentials : true
    };
    return this.http.get(this.trainingUrl+'limit='+limit+'&start='+start+'&user_id='+user_id); 
    }

    getAllTraining(user_id,brandId,limit,start,status){
    return this.http.get(this.allTrainingUrl+'userId='+user_id+'&brandId='+brandId+'&limit='+limit+'&start='+start+'&status='+status)
    }
    getUpdateCertification(filterObj){
      return this.http.post<any>(this.updateCertificationUrl, filterObj)
    }
    getTraningDetails(id){
    return this.http.get(this.trainingByIdUrl+id)
    }
    UpdateTraningDetails(filterObj:any): Observable<LoginResponse> {
    return this.http.post<any>(this.trainingUpdateByIdUrl, filterObj)
    }

    getUpcommingEvent(sort,filterObj,limit,start){
    const httpOptions = {
    headers: new HttpHeaders({
    'Content-Type':  'application/json'
    }),
    withCredentials : true
    };
    return this.http.get(this.upcommingUrl+'filter='+encodeURIComponent(JSON.stringify(filterObj))+'&limit='+limit+'&start='+start+'$sort='+encodeURIComponent(JSON.stringify(sort)));
    }

    getMyStory(filterObj){
    return this.http.get(this.storyUrl+'filter='+encodeURIComponent(JSON.stringify(filterObj)))
    }
    getAllMaterials(filterObj){
    return this.http.get(this.allMaterialsUrl+'filter='+encodeURIComponent(JSON.stringify(filterObj)))
    }
    getProfile(user_id, brand_id) {
    return this.http.get(this.profileUrl + '&user_id=' + user_id + '&brand_id=' + brand_id);
    }
}
